import { createAction, props } from '@ngrx/store';

export const setHeadBannerHeight = createAction(
  '[Layout] Set HeadBanner Height',
  props<{ payload: { height: number } }>()
);

export type LayoutActionsUnion = ReturnType<typeof setHeadBannerHeight>;
